module.exports = __webpack_public_path__ + "img/ecology6.cffaa18d.png";